const balanceNumberFromText = (value) => {
  if (!value) return 0;

  const normalizedValue = value.toString().replace(/[^\d,.-]/g, '');
  const decimalValue = document.documentElement.lang === 'de'
    ? normalizedValue.replace(/\./g, '').replace(',', '.')
    : normalizedValue.replace(/,/g, '');
  const numberValue = Number.parseFloat(decimalValue);

  return Number.isFinite(numberValue) ? numberValue : 0;
};

const formatBalanceCurrency = (amount, currency) => {
  const locale = document.documentElement.lang === 'de' ? 'de-DE' : 'en-US';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (_error) {
    return amount.toFixed(2);
  }
};

const updateBalanceCard = (card, data) => {
  const total = balanceNumberFromText(data.balance);
  const payable = balanceNumberFromText(data.payable);
  const pending = Math.max(total - payable, 0);

  const values = {
    total: data.balance,
    pending: formatBalanceCurrency(pending, data.currency),
    payable: data.payable
  };

  Object.entries(values).forEach(([key, value]) => {
    const element = card.querySelector(`[data-account-balance-value="${key}"]`);
    if (!element || !value) return;

    element.textContent = value;
    element.classList.remove('placeholder');
  });

  const balance = card.querySelector('.account-balance');
  balance?.classList.remove('load-account-balance');
  card.querySelector('.placeholder-glow')?.classList.remove('placeholder-glow');
  card.dataset.balanceCached = 'true';
};

const initializeBalancePopover = (card) => {
  const trigger = card.querySelector('[data-bs-toggle="popover"]');
  if (!trigger || !window.bootstrap?.Popover) return;

  window.bootstrap.Popover.getInstance(trigger)?.dispose();

  const defaultAllowList = window.bootstrap.Tooltip?.Default?.allowList || {};
  const allowList = { ...defaultAllowList };
  allowList.b = [...(allowList.b || []), 'style'];

  new window.bootstrap.Popover(trigger, {
    html: true,
    allowList
  });
};

const loadAccountBalance = (card) => {
  if (card.dataset.balanceCached === 'true' || !card.dataset.balanceUrl) return;
  if (card.dataset.balanceLoading === 'true') return;

  card.dataset.balanceLoading = 'true';

  fetch(card.dataset.balanceUrl, {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Balance request failed: ${response.status}`);
      return response.json();
    })
    .then((data) => updateBalanceCard(card, data))
    .catch(() => {
      const balance = card.querySelector('.account-balance');
      balance?.classList.remove('load-account-balance');
    })
    .finally(() => {
      card.dataset.balanceLoading = 'false';
    });
};

const initializeAccountsHistoryBalance = () => {
  const card = document.getElementById('user-account-balance');
  if (!card) return;

  initializeBalancePopover(card);
  loadAccountBalance(card);
};

document.addEventListener('DOMContentLoaded', initializeAccountsHistoryBalance);
document.addEventListener('turbolinks:load', initializeAccountsHistoryBalance);
const balanceNumberFromText = (value) => {
  if (!value) return 0;

  const normalizedValue = value.toString().replace(/[^\d,.-]/g, '');
  const decimalValue = document.documentElement.lang === 'de'
    ? normalizedValue.replace(/\./g, '').replace(',', '.')
    : normalizedValue.replace(/,/g, '');
  const numberValue = Number.parseFloat(decimalValue);

  return Number.isFinite(numberValue) ? numberValue : 0;
};

const formatBalanceCurrency = (amount, currency) => {
  const locale = document.documentElement.lang === 'de' ? 'de-DE' : 'en-US';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (_error) {
    return amount.toFixed(2);
  }
};

const updateBalanceCard = (card, data) => {
  const total = balanceNumberFromText(data.balance);
  const payable = balanceNumberFromText(data.payable);
  const pending = Math.max(total - payable, 0);

  const values = {
    total: data.balance,
    pending: formatBalanceCurrency(pending, data.currency),
    payable: data.payable
  };

  Object.entries(values).forEach(([key, value]) => {
    const element = card.querySelector(`[data-account-balance-value="${key}"]`);
    if (!element || !value) return;

    element.textContent = value;
    element.classList.remove('placeholder');
  });

  const balance = card.querySelector('.account-balance');
  balance?.classList.remove('load-account-balance');
  card.querySelector('.placeholder-glow')?.classList.remove('placeholder-glow');
  card.dataset.balanceCached = 'true';
};

const initializeBalancePopover = (card) => {
  const trigger = card.querySelector('[data-bs-toggle="popover"]');
  if (!trigger || !window.bootstrap?.Popover) return;

  window.bootstrap.Popover.getInstance(trigger)?.dispose();

  const defaultAllowList = window.bootstrap.Tooltip?.Default?.allowList || {};
  const allowList = { ...defaultAllowList };
  allowList.b = [...(allowList.b || []), 'style'];

  new window.bootstrap.Popover(trigger, {
    html: true,
    allowList
  });
};

const loadAccountBalance = (card) => {
  if (card.dataset.balanceCached === 'true' || !card.dataset.balanceUrl) return;
  if (card.dataset.balanceLoading === 'true') return;

  card.dataset.balanceLoading = 'true';

  fetch(card.dataset.balanceUrl, {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Balance request failed: ${response.status}`);
      return response.json();
    })
    .then((data) => updateBalanceCard(card, data))
    .catch(() => {
      const balance = card.querySelector('.account-balance');
      balance?.classList.remove('load-account-balance');
    })
    .finally(() => {
      card.dataset.balanceLoading = 'false';
    });
};

const initializeAccountsHistoryBalance = () => {
  const card = document.getElementById('user-account-balance');
  if (!card) return;

  initializeBalancePopover(card);
  loadAccountBalance(card);
};

document.addEventListener('DOMContentLoaded', initializeAccountsHistoryBalance);
document.addEventListener('turbolinks:load', initializeAccountsHistoryBalance);
